<template>
  <div class="period-summary">
    <div class="chart-container">
      <h5><i class="fal fa-calendar-check text-primary"></i> Resumen del Período</h5>

      <!-- Información del Período -->
      <div class="period-info">
        <div class="row">
          <div class="col-md-6">
            <div class="period-details">
              <div class="period-header">
                <div class="period-icon">
                  <i class="fal fa-calendar-alt"></i>
                </div>
                <div class="period-content">
                  <div class="period-title">Período Seleccionado</div>
                  <div class="period-value">{{ getPeriodLabel(periodo) }}</div>
                  <div class="period-dates" v-if="fechaInicio && fechaFin">
                    {{ formatDate(fechaInicio) }} - {{ formatDate(fechaFin) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="period-stats">
              <div class="stat-item">
                <div class="stat-icon text-success">
                  <i class="fal fa-check-circle"></i>
                </div>
                <div class="stat-content">
                  <div class="stat-value">{{ getPeriodDays() }}</div>
                  <div class="stat-label">Días del Período</div>
                </div>
              </div>
              <div class="stat-item">
                <div class="stat-icon text-info">
                  <i class="fal fa-clock"></i>
                </div>
                <div class="stat-content">
                  <div class="stat-value">{{ getPeriodHours() }}</div>
                  <div class="stat-label">Horas del Período</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Comparación con Períodos Anteriores -->
      <div class="period-comparison">
        <h6><i class="fal fa-chart-line text-warning"></i> Comparación con Períodos Anteriores</h6>
        <div class="comparison-grid">
          <div class="comparison-item">
            <div class="comparison-header">
              <div class="comparison-icon text-success">
                <i class="fal fa-arrow-up"></i>
              </div>
              <div class="comparison-content">
                <div class="comparison-label">Mejoras</div>
                <div class="comparison-value">+12.5%</div>
              </div>
            </div>
            <div class="comparison-description">
              Incremento en la tasa de resolución de solicitudes
            </div>
          </div>

          <div class="comparison-item">
            <div class="comparison-header">
              <div class="comparison-icon text-warning">
                <i class="fal fa-minus"></i>
              </div>
              <div class="comparison-content">
                <div class="comparison-label">Estable</div>
                <div class="comparison-value">0.0%</div>
              </div>
            </div>
            <div class="comparison-description">
              Tiempo promedio de resolución se mantiene estable
            </div>
          </div>

          <div class="comparison-item">
            <div class="comparison-header">
              <div class="comparison-icon text-danger">
                <i class="fal fa-arrow-down"></i>
              </div>
              <div class="comparison-content">
                <div class="comparison-label">Atención</div>
                <div class="comparison-value">-5.2%</div>
              </div>
            </div>
            <div class="comparison-description">
              Ligera disminución en la satisfacción del usuario
            </div>
          </div>
        </div>
      </div>

      <!-- Resumen Ejecutivo -->
       <!--
      <div class="executive-summary">
        <h6><i class="fal fa-file-alt text-primary"></i> Resumen Ejecutivo</h6>
        <div class="summary-content">
          <div class="summary-highlights">
            <div class="highlight-item positive">
              <div class="highlight-icon">
                <i class="fal fa-star"></i>
              </div>
              <div class="highlight-content">
                <div class="highlight-title">Punto Destacado</div>
                <div class="highlight-description">
                  El período muestra una mejora significativa en la eficiencia operativa,
                  con un incremento del 12.5% en la resolución de solicitudes.
                </div>
              </div>
            </div>

            <div class="highlight-item attention">
              <div class="highlight-icon">
                <i class="fal fa-exclamation-triangle"></i>
              </div>
              <div class="highlight-content">
                <div class="highlight-title">Requiere Atención</div>
                <div class="highlight-description">
                  Se observa una ligera disminución en la satisfacción del usuario (-5.2%),
                  lo que sugiere revisar los procesos de atención al cliente.
                </div>
              </div>
            </div>

            <div class="highlight-item recommendation">
              <div class="highlight-icon">
                <i class="fal fa-lightbulb"></i>
              </div>
              <div class="highlight-content">
                <div class="highlight-title">Recomendación</div>
                <div class="highlight-description">
                  Implementar encuestas de satisfacción más frecuentes y revisar
                  los tiempos de respuesta en canales críticos.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      -->

      <!-- Acciones Recomendadas -->

      <!--
      <div class="recommended-actions">
        <h6><i class="fal fa-tasks text-success"></i> Acciones Recomendadas</h6>
        <div class="actions-list">
          <div class="action-item" v-for="(accion, index) in getRecommendedActions()" :key="index">
            <div class="action-priority" :class="getActionPriorityClass(accion.prioridad)">
              {{ accion.prioridad }}
            </div>
            <div class="action-content">
              <div class="action-title">{{ accion.titulo }}</div>
              <div class="action-description">{{ accion.descripcion }}</div>
              <div class="action-timeline">{{ accion.timeline }}</div>
            </div>
          </div>
        </div>
      </div>
      -->

    </div>
  </div>
</template>

<script>
export default {
  name: 'PeriodSummary',
  props: {
    periodo: {
      type: String,
      default: 'mes'
    },
    fechaInicio: {
      type: String,
      default: null
    },
    fechaFin: {
      type: String,
      default: null
    }
  },
  methods: {
    getPeriodLabel(periodo) {
      const labels = {
        'semana': 'Semana',
        'mes': 'Mes',
        'trimestre': 'Trimestre',
        'anio': 'Año'
      }
      return labels[periodo] || periodo
    },

    formatDate(dateString) {
      if (!dateString) return 'N/A'
      const date = new Date(dateString)
      return date.toLocaleDateString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      })
    },

    getPeriodDays() {
      if (!this.fechaInicio || !this.fechaFin) {
        const periodDays = {
          'semana': 7,
          'mes': 30,
          'trimestre': 90,
          'anio': 365
        }
        return periodDays[this.periodo] || 30
      }

      const start = new Date(this.fechaInicio)
      const end = new Date(this.fechaFin)
      const diffTime = Math.abs(end - start)
      return Math.ceil(diffTime / (1000 * 60 * 60 * 24))
    },

    getPeriodHours() {
      return this.getPeriodDays() * 24
    },

    getRecommendedActions() {
      return [
        {
          prioridad: 'Alta',
          titulo: 'Revisar Procesos de Atención',
          descripcion: 'Analizar y optimizar los flujos de trabajo para mejorar la satisfacción del usuario',
          timeline: '1-2 semanas'
        },
        {
          prioridad: 'Media',
          titulo: 'Implementar Encuestas de Satisfacción',
          descripcion: 'Establecer un sistema de feedback más frecuente para identificar áreas de mejora',
          timeline: '2-3 semanas'
        },
        {
          prioridad: 'Baja',
          titulo: 'Capacitación de Agentes',
          descripcion: 'Desarrollar programas de entrenamiento para mejorar las habilidades de resolución',
          timeline: '1 mes'
        }
      ]
    },

    getActionPriorityClass(prioridad) {
      const classMap = {
        'Alta': 'priority-high',
        'Media': 'priority-medium',
        'Baja': 'priority-low'
      }
      return classMap[prioridad] || 'priority-default'
    }
  }
}
</script>

<style scoped>
.period-summary {
  margin-bottom: 30px;
}

.chart-container {
  background: white;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.chart-container h5 {
  color: #495057;
  margin-bottom: 20px;
  font-weight: 600;
}

.period-info {
  margin-bottom: 30px;
}

.period-details {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 15px;
}

.period-header {
  display: flex;
  align-items: center;
  gap: 15px;
}

.period-icon {
  font-size: 2rem;
  color: #1f4e79;
  flex-shrink: 0;
}

.period-content {
  flex-grow: 1;
}

.period-title {
  font-size: 0.9rem;
  color: #6c757d;
  margin-bottom: 5px;
}

.period-value {
  font-size: 1.5rem;
  font-weight: bold;
  color: #495057;
  margin-bottom: 5px;
}

.period-dates {
  font-size: 0.9rem;
  color: #6c757d;
}

.period-stats {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.stat-item {
  display: flex;
  align-items: center;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
  gap: 15px;
}

.stat-icon {
  font-size: 1.5rem;
  flex-shrink: 0;
}

.stat-content {
  flex-grow: 1;
}

.stat-value {
  font-size: 1.2rem;
  font-weight: bold;
  color: #495057;
  margin-bottom: 2px;
}

.stat-label {
  font-size: 0.8rem;
  color: #6c757d;
}

.period-comparison {
  margin-bottom: 30px;
}

.period-comparison h6 {
  color: #495057;
  margin-bottom: 15px;
  font-weight: 600;
}

.comparison-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 15px;
}

.comparison-item {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 15px;
}

.comparison-header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  gap: 15px;
}

.comparison-icon {
  font-size: 1.5rem;
  flex-shrink: 0;
}

.comparison-content {
  flex-grow: 1;
}

.comparison-label {
  font-weight: 600;
  color: #495057;
  margin-bottom: 5px;
}

.comparison-value {
  font-size: 1.2rem;
  font-weight: bold;
  color: #495057;
}

.comparison-description {
  font-size: 0.9rem;
  color: #6c757d;
  line-height: 1.4;
}

.executive-summary {
  margin-bottom: 30px;
}

.executive-summary h6 {
  color: #495057;
  margin-bottom: 15px;
  font-weight: 600;
}

.summary-content {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
}

.summary-highlights {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.highlight-item {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  padding: 15px;
  background: white;
  border-radius: 8px;
  border-left: 4px solid;
}

.highlight-item.positive {
  border-left-color: #28a745;
}

.highlight-item.attention {
  border-left-color: #ffc107;
}

.highlight-item.recommendation {
  border-left-color: #17a2b8;
}

.highlight-icon {
  font-size: 1.5rem;
  flex-shrink: 0;
  margin-top: 2px;
}

.highlight-item.positive .highlight-icon {
  color: #28a745;
}

.highlight-item.attention .highlight-icon {
  color: #ffc107;
}

.highlight-item.recommendation .highlight-icon {
  color: #17a2b8;
}

.highlight-content {
  flex-grow: 1;
}

.highlight-title {
  font-weight: 600;
  color: #495057;
  margin-bottom: 8px;
}

.highlight-description {
  font-size: 0.9rem;
  color: #6c757d;
  line-height: 1.4;
}

.recommended-actions h6 {
  color: #495057;
  margin-bottom: 15px;
  font-weight: 600;
}

.actions-list {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
}

.action-item {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  padding: 15px;
  background: white;
  border-radius: 8px;
  margin-bottom: 15px;
}

.action-item:last-child {
  margin-bottom: 0;
}

.action-priority {
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 600;
  color: white;
  flex-shrink: 0;
  margin-top: 2px;
}

.priority-high { background-color: #dc3545; }
.priority-medium { background-color: #ffc107; color: #212529; }
.priority-low { background-color: #28a745; }
.priority-default { background-color: #6c757d; }

.action-content {
  flex-grow: 1;
}

.action-title {
  font-weight: 600;
  color: #495057;
  margin-bottom: 5px;
}

.action-description {
  font-size: 0.9rem;
  color: #6c757d;
  margin-bottom: 5px;
  line-height: 1.4;
}

.action-timeline {
  font-size: 0.8rem;
  color: #17a2b8;
  font-weight: 500;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .period-value {
    font-size: 1.2rem;
  }

  .comparison-grid {
    grid-template-columns: 1fr;
  }

  .highlight-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .action-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .action-priority {
    align-self: flex-start;
  }
}
</style>
